export enum PMOrderType {
  ZML1 = 'ZML1',
  ZML2 = 'ZML2',
  ZML3 = 'ZML3',
  ZML4 = 'ZML4',
  ZML5 = 'ZML5',
  ZML6 = 'ZML6',
  ZML7 = 'ZML7',
}
